import { createContext } from 'react';
export const SuiExternalContext = createContext(false);
//# sourceMappingURL=SuiExternalContext.js.map